
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from 'components/home/home';
import StickersPage from 'components/stickers/stickers-page';
import CollectionPage from 'components/collection/collection-page';

import './App.css';

function App() {
  return (
    <div className="App">
      {/* <Header /> */}
      <Routes>
        <Route index element={<CollectionPage />} />
        <Route path='stickers' element={<StickersPage />} />
      </Routes>
    </div>
  );
}

export default App;
